export default __webpack_public_path__ + "static/media/Nathaniel Fernandes - Developer.b6339a3c.jpg";